module.exports = __webpack_public_path__ + "static/media/meditation7.aa39df82.mp3";